import { render, staticRenderFns } from "./ResendCode.vue?vue&type=template&id=06d57abd&scoped=true&"
import script from "./ResendCode.vue?vue&type=script&lang=js&"
export * from "./ResendCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d57abd",
  null
  
)

export default component.exports